import { get } from "../api/apiClient";
import { authHeader } from "../api/authHeader";

const API_PREFIX = "/dataAnalysis";

export const init = async request => {
  const param = `?studentId=${request.studentId}&listId=${request.listId}`;

  const response = await get(`${API_PREFIX}/${param}`, authHeader());
  console.log("response", response);
  return response.data;
};
